<kf-tooltip-anchor>

  <div class='hint-tooltip-anchor'>
    <div 
      each={ t in Object.values(props.tooltips) }
      class="hint-tooltip-wrapper"
      data-key={ t.key }
    >
      <!-- the context will be set programmatically -->
    </div>
  </div>

  <script>

    const D = 10;
    const D2 = 2;
    const T = 0.7;

    export default {
      
      refresh() {
        const pageWidth = Math.max(
          document.body.scrollWidth,
          document.documentElement.scrollWidth,
          document.body.offsetWidth,
          document.documentElement.offsetWidth,
          document.body.clientWidth,
          document.documentElement.clientWidth
        );
        const t = this.props.tooltips ?? {}
        for (const [key, { innerHTML, x, y }] of Object.entries(t)) {
          const el = this.root.querySelector(`[data-key=${JSON.stringify(key)}]`);
          if (!el) {
            continue;
          }
          el.innerHTML = innerHTML;
          if (x / pageWidth >= T) {
            el.style.left = `${(x ?? 0) - D2 - (el.clientWidth ?? 50)}px`;
          } else {
            el.style.left = `${(x ?? 0) + D}px`;
          }
          el.style.top = `${(y ?? 0) + D}px`;
        }
      },

      onMounted() {
        this.refresh();
      },

      onUpdated() {
        this.refresh();
      },

    };
  </script>
  <style>
    .hint-tooltip-anchor {
      position: absolute;
      margin: 0px;
      padding: 0px;
      left: 0px;
      top: 0px;
      width: 0px;
      height: 0px;
      overflow: visible;
    }

    .hint-tooltip-wrapper {
      position: absolute;
      z-index: 10000;
    }

    .hint-tip {
      min-width: 180px;
      display: block;
      font-weight: normal;
      font-size: 14px;
      padding: 0.6em;
      background-color: rgb(255, 255, 255);
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
      border-radius: 3px;
      z-index: 1;
      margin: 0.7em;
    }

  </style>
</kf-tooltip-anchor>